import { memo } from 'react'

import { CloudDoneOutlined, SaveAsOutlined } from '@mui/icons-material'

import { Chip, ChipProps } from '@collaborate-health/uikit'

import { ArticlePublicationStatus, ArticlePublicationStatusDisplayName } from '../../enums'

const ArticlePublicationStatusToColorMap: Record<ArticlePublicationStatus, ChipProps['color']> = {
  [ArticlePublicationStatus.Draft]: 'default',
  [ArticlePublicationStatus.Published]: 'primary',
}

const ArticlePublicationStatusToIconMap: Record<ArticlePublicationStatus, ChipProps['icon']> = {
  [ArticlePublicationStatus.Draft]: <SaveAsOutlined />,
  [ArticlePublicationStatus.Published]: <CloudDoneOutlined />,
}

export interface ArticlePublicationStatusChipProps {
  status: ArticlePublicationStatus
}

const ArticlePublicationStatusChip: React.FC<ArticlePublicationStatusChipProps> = ({ status }) => {
  return (
    <Chip
      size='small'
      icon={ArticlePublicationStatusToIconMap[status]}
      color={ArticlePublicationStatusToColorMap[status]}
      label={ArticlePublicationStatusDisplayName[status]}
    />
  )
}

ArticlePublicationStatusChip.defaultProps = {
  status: ArticlePublicationStatus.Draft,
}

export default memo(ArticlePublicationStatusChip)

